import React from 'react';
import DeviceStatus from './DeviceStatus';
import { Row } from 'react-flexbox-grid';
import FontIcon from 'material-ui/FontIcon';
import translate from '../../lib/i18n/translate'
import './DeviceStatusList.css'


export const DeviceStatusList = ({status, strings}) => {

    const {Safes} = strings;

    return (
        <div className="BranchDeviceList">
	        <div className="MiddleHeader">
	            <FontIcon className="material-icons left">list</FontIcon>
	            <div className="MiddleHeaderText">{Safes}</div>
	        </div>
	        <Row className="BranchDevices">
	            {
	            status.map((s, i) =>
	                    <DeviceStatus key={i} device={s}/>
	                )
	            }
	        </Row>
        </div>
    );
};


export default translate('DeviceStatusList')(DeviceStatusList);



// WEBPACK FOOTER //
// ./src/components/deviceStatus/DeviceStatusList.js